export default "__VITE_ASSET__Dk1hciLC__"